export const isDevelopment = () =>
  ['development', 'local'].includes(
    (process.env.VUE_APP_ENV || 'local').toLowerCase()
  );
